export default __webpack_public_path__ + "static/media/20210501_103958-min.25a28a9b.jpg";